import { gql } from '@apollo/client';

export const REGISTER_BRAND_USER = gql`
  mutation REGISTER_BRAND_USER(
    $email: String!
    $name: String!
    $password: String!
    $passwordConfirm: String!
    $userType: UserType
  ) {
    registerUser(
      email: $email
      name: $name
      password: $password
      passwordConfirm: $passwordConfirm
      userType: $userType
    ) {
      id
      email
      userType
    }
  }
`;
